<i18n>
{
  "de": {
    "search": "Suche",
    "selectAll": "Alle auswählen",
    "deselectAllLabel": "Deselect all",
    "filterByContent": "Content",
    "deselectAll": "Deselect all"
  },
  "en": {
    "search": "Search",
    "selectAll": "Select all",
    "deselectAllLabel": "Deselect all",
    "filterByContent": "Content",
    "deselectAll": "Deselect all"
  }
}
</i18n>

<template>
  <div>
    <section>
      <vue-multi-select
        ref="multiSelectMonths"
        v-model="values"
        class="multi-select filter-content"
        :class="{
          'filter-content-mobile': layout === 'mobileFilterPosts',
          'has-selections': hasSelections
        }"
        :options="options"
        :filters="filters"
        :btnLabel="btnLabel"
        :position="layout === 'mobileFilterPosts' ? 'bottom-right' : 'bottom-left'"
        :searchPlaceholder="`${$t('search')}...`"
        :selectOptions="contentOptions"
        @selectionChanged="executeFilter"
        @open="onDropdownOpen"
      />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'

export default {
  props: ['layout'],
  components: { vueMultiSelect },
  name: 'Filter-Posts-Content',
  data: () => ({
    values: [],
    options: {
      multi: true,
      labelValue: '_id',
      cssSelected: (option) => option.selected ? { 'font-weight': 'bold', color: '#fb3e52' } : ''
    },
    filters: [{
      nameAll: 'select all',
      nameNotAll: 'unselect all',
      func() {
        return true
      }
    }],
    filterInitialized: false
  }),
  computed: {
    hasSelections() {
      return this.values && this.values.length > 0
    },
    contentOptions() {
      return [{
        _id: 'video',
        name: '🎥 Videos'
      }, {
        _id: 'audio',
        name: '🎧  Audios'
      }, {
        _id: 'image',
        name: '📸  Images'
      }, {
        _id: 'zip',
        name: '🗜️  Zips'
      }, {
        _id: 'pdf',
        name: '📄  PDF'
      }]
    },
    ...mapState(['artist', 'postFilter'])
  },
  methods: {
    btnLabel() {
      return this.$t('filterByContent') + ((this.values || []).length ? ` (${this.values.length})` : '')
    },

    clearResult() {
      this.values = []
    },

    resetFilterUI() {
      this.values = []
      this.filterInitialized = false
    },

    initFilter() {
      this.filters[0].nameAll = this.$t('selectAll')
      this.filters[0].nameNotAll = this.$t('deselectAll')
    },

    restoreFilter() {
      this.filterInitialized = false

      if (
        !this.postFilter ||
        !this.postFilter.content ||
        !this.postFilter.content.length
      ) {
        return this.clearResult()
      }

      this.values = this.postFilter.contents
      this.filterInitialized = true
    },

    onDropdownOpen() {
      this.$root.$emit('closeOtherFilterDropdowns', 'content')
    },

    closeDropdown() {
      this.$refs.multiSelectMonths?.closeMultiSelect?.()
    },

    async executeFilter() {
      if (!this.filterInitialized) {
        this.values = this.postFilter.contents
        this.filterInitialized = true
        return
      }
      const filter = { contents: this.values }
      this.$emit('filter', filter)
    }
  },

  mounted() {
    if (this.artist) {
      this.initFilter()
    }

    this.$root.$on('recoverPostFilter', this.restoreFilter)
    this.$root.$on('resetAllFilters', this.resetFilterUI)
    this.$root.$on('closeOtherFilterDropdowns', (openedBy) => {
      if (openedBy !== 'content') {
        this.closeDropdown()
      }
    })
    this.filterInitialized = true
  },

  beforeDestroy() {
    this.$root.$off('recoverPostFilter', this.restoreFilter)
    this.$root.$off('resetAllFilters', this.resetFilterUI)
    this.$root.$off('closeOtherFilterDropdowns')
  }
}
</script>

<style lang="scss">
.filter-content {
  .checkboxLayer {
    min-width: 222px !important;
    max-width: 222px;
  }

  &.filter-content-mobile {
    .checkboxLayer {
      min-width: 120px !important;
      max-width: 120px;
    }
  }
}
</style>
